module.exports = __webpack_public_path__ + "img/ticket.ec965e07.svg";